import { GETMEMBERLIST_SUCCESS, GETMEMBERLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getApprovallistReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETMEMBERLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETMEMBERLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getApprovallistReducer;



